import { Observable } from 'rxjs/observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';


@Injectable()
export class ColorService {

    bg_colors : BehaviorSubject<any> = new BehaviorSubject([]);

    constructor() {
        this.bg_colors.next([
            {bg_class: "bg-purple"  ,  bg_name:'Purple'    , code: '#6d4072' },
            {bg_class: "bg-blue"    ,  bg_name:'Blue'      , code: '#3974e2' },
            {bg_class: "bg-madison" ,  bg_name:'Madison'   , code: '#313e4d' },
            {bg_class: "bg-brown"   ,  bg_name:'Brown'     , code: '#4f331b' },
            {bg_class: "bg-green"   ,  bg_name:'Green'     , code: '#008000' },
            {bg_class: "bg-olive"   ,  bg_name:'Olive'     , code: '#368763' },
            {bg_class: "bg-teal"    ,  bg_name:'Teal'      , code: '#15b49c' },
            {bg_class: "bg-red"     ,  bg_name:'Red'       , code: '#c9302c' },
            {bg_class: "bg-valencia",  bg_name:'Valencia'  , code: '#D64646' },
            {bg_class: "bg-orange"  ,  bg_name:'Orange'    , code: '#FF681F' },
            {bg_class: "bg-mustard" ,  bg_name:'Mustard'   , code: '#f0a13c' },
            {bg_class: "bg-yellow"  ,  bg_name:'Yellow'    , code: '#f6bb15' },
            {bg_class: "bg-white"   ,  bg_name:'White'     , code: '#ffffff' },
            {bg_class: "bg-off-white", bg_name:'Off White' , code: '#f5f5f5' },
            {bg_class: "bg-gray"    ,  bg_name:'Gray'      , code: '#d2d6de' },
            {bg_class: "bg-muted"   ,  bg_name:'Muted'     , code: '#777777' },
            {bg_class: "bg-charcoal",  bg_name:'Charcoal'  , code: '#1f282e' },
            {bg_class: "bg-black"   ,  bg_name:'Black'     , code: '#111111' }
        ]);
    }

}


// WEBPACK FOOTER //
// ./src/Services/ColorService.ts